import { FormattedMessage } from 'react-intl';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Hook } from '@rossum/api-client/hooks';
import { IconCode } from '@rossum/ui/icons/tabler';
import { Button, Paper, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { isPublicFunction } from '../../../helpers';

type Props = {
  selectedExtension: Hook;
  isFromStore: boolean;
  routeUrl: string;
};

export const ViewCodePart = ({
  routeUrl,
  selectedExtension,
  isFromStore,
}: Props) => {
  const location = useLocation();

  if (!isPublicFunction(selectedExtension)) {
    return null;
  }

  const { code } = selectedExtension.config;

  return (
    <Stack component={Paper} elevation={8} sx={{ p: 2 }} spacing={2}>
      {isFromStore && (
        <Stack spacing={1}>
          <Typography variant="h6">
            <FormattedMessage id="containers.settings.extensions.fromStoreTitle" />
          </Typography>
          <Typography variant="body2" color="secondary">
            <FormattedMessage id="containers.settings.extensions.fromStoreNote" />
          </Typography>
        </Stack>
      )}
      <Stack spacing={2} direction="row" alignItems="center">
        <Button
          component={RouterLink}
          to={{ pathname: `${routeUrl}/code`, state: location.state }}
          variant="outlined"
          color="secondary"
          startIcon={
            <SvgIcon fontSize="large">
              <IconCode />
            </SvgIcon>
          }
          data-cy="extensions-edit-code-button"
          sx={{
            '&:hover': {
              color: theme => theme.palette.secondary.main,
            },
          }}
        >
          <FormattedMessage
            id={
              isFromStore
                ? 'containers.settings.extensions.function.viewTestCode'
                : 'containers.settings.extensions.function.editCode'
            }
          />
        </Button>
        {code === '' && (
          <Typography
            variant="body2"
            color="secondary"
            data-cy="extensions-function-empty-message"
          >
            <FormattedMessage id="containers.settings.extensions.function.editCode.empty" />
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
